module.exports = "/_next/static/images/LeveragePreBuiltCloudSources-ca8c58e6d17029ba34dac03736600d58.webp";